(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-tabs"] && !Shopify.designMode) return;
  try {
    
  function hideEmptyTabs() {
    let firstVisibleTab = null;
    
    document.querySelectorAll('.tab-panel').forEach(panel => {
      // Check if panel is empty or only contains whitespace
      const isEmpty = !panel.innerHTML.trim() || panel.innerHTML.trim() === '';
      
      if (isEmpty) {
        // Hide the panel
        panel.style.display = 'none';
        // Find and hide the corresponding tab button
        const tabButton = document.querySelector(`[data-tab-target="${panel.id}"]`);
        if (tabButton) {
          tabButton.style.display = 'none';
        }
      } else if (!firstVisibleTab) {
        // Store the first non-empty tab
        firstVisibleTab = panel;
      }
    });

    // If we found a visible tab, activate it
    if (firstVisibleTab) {
      // Remove active class from all tabs and panels
      document.querySelectorAll('.tab-button').forEach(button => button.classList.remove('active'));
      document.querySelectorAll('.tab-panel').forEach(panel => panel.classList.remove('active'));
      
      // Activate the first visible tab and its button
      firstVisibleTab.classList.add('active');
      const firstButton = document.querySelector(`[data-tab-target="${firstVisibleTab.id}"]`);
      if (firstButton) {
        firstButton.classList.add('active');
      }
    }
  }

  function switchTab(event) {
    const targetPanel = event.currentTarget.dataset.tabTarget;

    // Remove 'active' class from all buttons and panels
    document.querySelectorAll('.tab-button').forEach(button => button.classList.remove('active'));
    document.querySelectorAll('.tab-panel').forEach(panel => panel.classList.remove('active'));

    // Add 'active' class to the clicked button and corresponding panel
    event.currentTarget.classList.add('active');
    document.getElementById(targetPanel).classList.add('active');
  }

  // Add event listeners to all tab buttons
  document.querySelectorAll('.tab-button').forEach(button => {
    button.addEventListener('click', switchTab);
  });

  // Check for empty tabs when the page loads
  hideEmptyTabs();

  } catch(e) { console.error(e); }
})();
})();
